import React from "react";
import styled from "styled-components";
import { FaPhone, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';

const AboutContainer = styled.div`
  padding: 100px 0;
  background: linear-gradient(to right, #536976, #292e49);
`;

const AboutWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

const AboutImage = styled.div`
  flex: 1;
  max-width: 50%;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 30px;
  }
`;

const ContactInfo = styled.div`
  flex: 1;
  padding: 1rem;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  svg {
    margin-right: 10px;
    font-size: 20px;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  span {
    font-size: 16px;
    color: #fff;
  }
`;

const Description = styled.p`
  margin-top: 20px;
  font-size: 18px;
  color: #fff;
`;

const Button = styled.button`
  text-decoration: none;
  border: none;
  outline: none;
  color: #fff;
  font-weight: 700;
  border-radius: 30px;
  font-size: 12px;
  padding: 20px 40px;
  background-color: #ffac1b;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ff971b;
  }
`;

const About = () => {
  const handleLocationClick = () => {
    window.open("https://maps.google.com/maps?q=-8.16685864469128,112.51408013520346", "_blank");
  };

  return (
    <AboutContainer>
      <div className="container">
        <div className="row">
          <AboutWrapper>
            <AboutImage>
              <img src="/img/adonan1.jpg" alt="adonan1" />
            </AboutImage>
            <ContactInfo>
              <h3 style={{ color: '#fff', fontSize: '30px', fontWeight: 'bold' }}>Contact</h3>
              <h1 style={{ color: '#fff', fontSize: '40px', fontWeight: 'bold' }}>Delivery Order</h1>
              <ContactItem>
                <FaPhone />
                <span style={{ color: '#fff', fontSize: '18px', fontWeight: 'bold' }}>
                  Phone: +62 823-3688-1945
                </span>
              </ContactItem>
              <ContactItem>
                <FaMapMarkerAlt />
                <span style={{ color: '#fff', fontSize: '18px', fontWeight: 'bold' }}>
                  Location: Jalan A.Yani No.17, RT.09/RW.03, Krajan Senggreng, Senggreng, Kec. Sumberpucung,
                  Kabupaten Malang, Jawa Timur 65165
                </span>
              </ContactItem>
              <ContactItem>
                <FaEnvelope />
                <span style={{ color: '#fff', fontSize: '18px', fontWeight: 'bold' }}>
                  Email: fransiscorangga@gmail.com
                </span>
              </ContactItem>
              <Description>
                Jadi, jangan ragu untuk menghubungi kami melalui WhatsApp dan biarkan kami menciptakan kue ulang tahun yang istimewa
                untuk Anda. Rasakan kemudahan pemesanan dengan Razqa Cake Ulang Tahun melalui WhatsApp sekarang!
              </Description>
              <div className="about__btn">
                <Button onClick={handleLocationClick}>
                  VIEW LOCATION
                </Button>
              </div>
            </ContactInfo>
          </AboutWrapper>
        </div>
      </div>
    </AboutContainer>
  );
};

export default About;
